import { IRefractionSchema } from "../@types/refraction";
import axios from "../utils/axios";

export class RefractionService {
  createRefraction(patientId: any, data: IRefractionSchema) {
    return axios.post(`/patient/${patientId}/refraction`, data);
  }

  getRefraction(patientId: any, refractionId?: any) {
    return axios.get(
      `/patient/${patientId}/refraction?refractionId=${refractionId}`
    );
  }

  /**
   * All refractions for a patient, newest first.
   *
   * The endpoint returns them unordered, so the sort happens here — callers
   * that want "the current prescription" need the most recent one, and taking
   * `[0]` off an unordered list would silently pick an old refraction.
   */
  async getLatestRefraction(patientId: string) {
    const res = await axios.get(`/patient/${patientId}/refraction`);
    const rows: any[] = Array.isArray(res.data) ? res.data : [];
    return [...rows].sort((a, b) => Number(b?.id ?? 0) - Number(a?.id ?? 0))[0];
  }
}
